<template>
    <div>
        <loader v-if="pageLoader"></loader>
        <div class="wt-dashborad-chart-header advanced-seat-tab-content-header  d-flex justify-content-end align-items-center mt-4 mb-2">            
            <ul class="switch-toggle d-flex align-items-center p-0" id="myTab" role="tablist">
                <li class="nav-item switch-toggle-label nav-item ml-2" v-for="(profit_j,index) in profitJson" :key="index">
                    <a class="nav-link"   v-bind:class="{'active':tradingProfitTab == index}"  href="javascript:void(0);" role="tab" aria-controls="usd"
                        @click="changeTradingProfitTab(index)"
                    >{{ index }}</a>
                </li>
            </ul>
        </div>
        <div v-show="(Object.keys(drawdownChartData).length && drawdownChartData.series.length && drawdownChartData.series[0].data.length) ">
            <div id="drawdown_chart" class="drawdownchart"></div>
        </div>
        <div v-if="!(Object.keys(drawdownChartData).length && drawdownChartData.series.length && drawdownChartData.series[0].data.length) " class="nodataFound position-relative">
            <div class="boxedNodata d-flex align-items-center justify-content-center">
                <div class="noDataPic">
                    <img src="../../../../../../static/website/images/no-data.svg" alt="" />
                    <!-- <span class="f-16">No trading history found.</span> -->
                </div>
            </div>
            <!-- <img src="../../../../../static/hanko/images/new/errorGraphCandle.png" alt="graph" />  -->
        </div>
        <div class="d-flex justify-content-between align-items-center" v-if="(Object.keys(drawdownChartData).length && drawdownChartData.series.length && drawdownChartData.series[0].data.length) ">
            <div class="wt-dashborad-chart-footer mt-3 mb-2 ">
                <ul class="d-flex align-items-center p-0">
                    <li v-for="item,key in dateDrop" @click.prevent.stop="dateDropSelected = key" :class="{'active':dateDropSelected == key}">{{ item }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import * as am4core from "../../../../../../node_modules/@amcharts/amcharts4/core"
import * as am4charts from "../../../../../../node_modules/@amcharts/amcharts4/charts"
import am4themes_animated from "../../../../../../node_modules/@amcharts/amcharts4/themes/animated"

import { commonAllmixins } from "@/plugins/commonAll";
export default {
    emits:['updateSelectedTimeFrame'],
    props:['dateDrop','dateDropSelected'],
    mixins: [commonAllmixins],
    data:function(){
        return {
            tradingProfitTab : 'USD',
            profitJson : {
                'USD' : 'USD',
                'Pips' : 'pips',
                // 'ROI' : '%'
            },
            xAxisColor:'#666666',
            yAxisColor:'#404d7b',
            leader_id:'',
            pageLoader : false,
            drawdownJson :  {
                'DRAWDOWN_DAILY_MONEY' : 'Daily Drawdown',
                'CLOSED_PROFIT_MONEY' : 'Closed Trades Only',
                'TOTAL_PROFIT_MONEY' : 'Profit',
                'DRAWDOWN_DAILY' : 'Daily Drawdown',
                'CLOSED_PROFIT' : 'Closed Trades Only',
                'TOTAL_PROFIT' : 'Profit'
            },
            chart:null
        }
    },
    watch:{
        'dateDropSelected':function(){
            this.getDrawdownData();
        }
    },
    mounted(){
        this.getDrawdownData();
    },
    methods:{
        setTimeframe(date_drop){
            this.$emit('updateSelectedTimeFrame',date_drop)
        },
        drawdownChart() {
            // Destroy existing chart instance if any
           this.destroyChart();

            // Create chart instance
            let chart = am4core.create("drawdown_chart", am4charts.XYChart);

            // Set themes
            am4core.useTheme(am4themes_animated);
            // Date and number formatting
            chart.dateFormatter.dateFormat = "dd MMM yyyy";
            chart.dateFormatter.inputDateFormat = "yyyy-MM-dd"; // Example format
            chart.numberFormatter.numberFormat = "#.##";

            // Set chart properties
            chart.paddingLeft = 0;
            chart.paddingRight = 0;

            // chart.colors.list = [
            //     am4core.color(0x484ddf),
            //     am4core.color(0xf3c993),
            //     am4core.color(0x2ad6b1),
            // ];

            // Add cursor
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.behavior = "zoomX";
            chart.cursor.lineY.disabled = true;
            chart.cursor.lineX.disabled = true;

            // Create axes
            let xAxis = chart.xAxes.push(new am4charts.DateAxis());
            xAxis.renderer.grid.template.disabled = true;
            // xAxis.renderer.labels.template.fill = am4core.color(this.xAxisColor);
            xAxis.renderer.labels.template.fontSize = 12;

            let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
            yAxis.extraMin = 0.2;
            yAxis.renderer.grid.template.disabled = true;
            // yAxis.renderer.labels.template.fill = am4core.color(this.yAxisColor);
            yAxis.renderer.labels.template.fontSize = 12;

             //to disable tooltip over xaxis and yaxis
             xAxis.cursorTooltipEnabled = false;
            yAxis.cursorTooltipEnabled = false;

            // Add labels
            let xAxisLabel = chart.plotContainer.createChild(am4core.Label);
            xAxisLabel.text = "[#" + this.xAxisColor + "] Date [/]";
            xAxisLabel.fontSize = 12;
            xAxisLabel.align = "center";
            xAxisLabel.valign = "bottom";
            xAxisLabel.dy = 10; // Adjust position

            let yAxisLabel = yAxis.renderer.createChild(am4core.Label);
            yAxisLabel.text = this.tradingProfitTab == 'Pips' ? "[#" + this.xAxisColor + "] Pips" : "[#" + this.xAxisColor + "] " + this.leaderDetail.trader.stats.profile.baseCurrencyName;
            yAxisLabel.rotation = -90;
            yAxisLabel.fontSize = 12;
            // yAxisLabel.fill = am4core.color(0x666666);
            yAxisLabel.align = "left";
            yAxisLabel.valign = "middle";

            // Add legend
            chart.legend = new am4charts.Legend();
            chart.legend.position = "bottom";
            chart.legend.labels.template.fontSize = 12;
            chart.legend.labels.template.fontWeight = "600";
            chart.legend.markers.template.width = 13;
            chart.legend.markers.template.height = 13;

            // Add series
            this.drawdownChartData.series.forEach((val, i) => {
                if (val.type == 'TOTAL_PROFIT_MONEY' || val.type == 'CLOSED_PROFIT_MONEY' || val.type == 'TOTAL_PROFIT' || val.type == 'CLOSED_PROFIT') {
                    let series = chart.series.push(new am4charts.LineSeries());
                    series.name = this.drawdownJson[val.type];
                    series.dataFields.valueY = "y";
                    series.dataFields.dateX = "x";
                    if(i == 1){
                        series.stock = am4core.color("#05795C");
                        series.fill = am4core.color("#05795C");
                    }else{
                        series.stock = am4core.color("#079C77");
                        series.fill = am4core.color("#079C77");
                    }
                    series.tooltipText = (val.type == 'TOTAL_PROFIT_MONEY' || val.type == 'TOTAL_PROFIT') ? "[bold]Live Profit[/]: {valueY} \n [bold]Date[/]: {dateX.formatDate('dd MMM yyyy')}" : (val.type == 'CLOSED_PROFIT_MONEY' || val.type == 'CLOSED_PROFIT') ? "[bold]Closed Trades Only[/]: {valueY} \n [bold]Date[/]: {dateX.formatDate('dd MMM yyyy')}" : "";
                    series.strokeWidth = 2;
                    series.data = val.data;
                } else {
                    let volumeSeries = chart.series.push(new am4charts.ColumnSeries());
                    volumeSeries.name = this.drawdownJson[val.type];
                    volumeSeries.dataFields.valueY = "y";
                    volumeSeries.dataFields.dateX = "x";
                    volumeSeries.stroke = am4core.color("#09C395");
                    volumeSeries.fill = am4core.color("#09C395");
                    volumeSeries.tooltipText = "[bold]Live Daily Drawdown[/]: {valueY} \n [bold]Date[/]: {dateX.formatDate('dd MMM yyyy')}";
                    volumeSeries.columns.template.width = am4core.percent(40);
                    volumeSeries.data = val.data;
                }
            });

            chart.legend.data = chart.series.values;
            chart.appear(1000, 100);
        },

        // drawdownChart(){
        //     this.destroyChart();
        //     var root = am5.Root.new("drawdown_chart");
        //     let themes = [
        //         am5themes_Animated.new(root),
        //         am5themes_Responsive.new(root)
        //     ];

        //     if(this.auth_store.mode == 'dark'){
        //         themes.push(am5themes_Dark.new(root));
        //     }

        //     root.setThemes(themes);
        //     root.dateFormatter.setAll({
        //         dateFormat: "dd MMM yyyy",
        //         dateFields: ["valueX"]
        //     });
        //     root.numberFormatter.setAll({
        //       numberFormat: "#a",
        //       smallNumberThreshold: 0.001
        //     });


        //     // Create chart
        //     // https://www.amcharts.com/docs/v5/charts/xy-chart/
        //     var chart = root.container.children.push(am5xy.XYChart.new(root, {
        //         focusable: false,
        //         panX: false,
        //         panY: false,
        //         wheelX: "panX",
        //         wheelY: "zoomX",
        //         paddingLeft: 0,
        //         paddingRight: 0,
        //     }));

        //     chart.get("colors").set("colors", [
        //         am5.color(0x484ddf),
        //         am5.color(0xf3c993),
        //         am5.color(0x2ad6b1),
        //     ]);

        //     // Add cursor
        //     // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
        //     var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
        //       behavior: "zoomX"
        //     }));
        //     cursor.lineY.set("visible", false);
        //     cursor.lineX.set("visible", false);
        //     var xAxis = chart.xAxes.push(am5xy.DateAxis.new(root, {
        //       maxDeviation: 0,
        //       baseInterval: {
        //         timeUnit: "day",
        //         count: 1
        //       },
        //     renderer: am5xy.AxisRendererX.new(root, {}),
        //       tooltip: am5.Tooltip.new(root, {})
        //     }));

        //     var label = am5.Label.new(root, {
        //         text: "[#"+this.xAxisColor+"] Date [/]",
        //         x: am5.p50,
        //         centerY: am5.p50,
        //         fontSize: 12,
        //     })
        //     xAxis.children.push( label );

        //     var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
        //       extraMin: 0.2,
        //       renderer: am5xy.AxisRendererY.new(root, {})
        //     }));
        //     xAxis.get("renderer").grid.template.set("forceHidden", true);
        //     yAxis.get("renderer").grid.template.set("forceHidden", true);
        //     var label1 = am5.Label.new(root, {
        //         rotation: -90,
        //         text: this.tradingProfitTab=='Pips' ?"[#"+this.xAxisColor+"] "+ 'Pips' :"[#"+this.xAxisColor+"] "+ this.leaderDetail.trader.stats.profile.baseCurrencyName,
        //         fill: am5.color(0x666666),
        //         y: am5.p50,
        //         centerX: am5.p50,
        //         fontSize: 12,
        //     })
        //     yAxis.children.unshift( label1 );
        //      let yRenderer = yAxis.get("renderer");
        //     yRenderer.grid.template.setAll({
        //         stroke: am5.color(0x666666),
        //         strokeWidth: 1
        //     });

        //     var legend = chart.bottomAxesContainer.children.push(am5.Legend.new(root, {
        //         x: am5.percent(50),
        //         centerX: am5.percent(50),
        //         // layout: root.horizontalLayout,
        //         useDefaultMarker: true,
        //         // paddingTop: 15,
        //     }));

        //     legend.labels.template.setAll({
        //         fontSize: 12,
        //         fontWeight: "600"
        //     });
        //     legend.markerRectangles.template.setAll({
        //         cornerRadiusTL: 20,
        //         cornerRadiusTR: 20,
        //         cornerRadiusBL: 20,
        //         cornerRadiusBR: 20
        //     });
        //     legend.markers.template.setAll({
        //         width: 13,
        //         height: 13
        //     });
        //     this.drawdownChartData.series.reverse().forEach((val) => {
        //         if(val.type == 'TOTAL_PROFIT_MONEY' || val.type == 'CLOSED_PROFIT_MONEY' || val.type == 'TOTAL_PROFIT' || val.type == 'CLOSED_PROFIT'){
        //             var series = chart.series.push(am5xy.LineSeries.new(root, {
        //                 legendLabelText: this.drawdownJson[val.type],
        //                 name: "Series",
        //                 xAxis: xAxis,
        //                 yAxis: yAxis,
        //                 valueYField: "y",
        //                 valueXField: "x",
        //                 tooltip: am5.Tooltip.new(root, {
        //                 labelText: (val.type == 'TOTAL_PROFIT_MONEY' || val.type == 'TOTAL_PROFIT') ? "[bold]Live Profit[/]: {valueY} \n [bold]Date[/]: {valueX.formatDate('dd MMM yyyy')}" : (val.type == 'CLOSED_PROFIT_MONEY' || val.type == 'CLOSED_PROFIT') ? "[bold]Closed Trades Only[/]: {valueY} \n [bold]Date[/]: {valueX.formatDate('dd MMM yyyy')}" : "",
        //               })
        //             }));
        //             series.strokes.template.setAll({
        //                 strokeWidth: 2
        //             });
        //             series.data.setAll(val.data);
        //             //legend.data.unshift(series);

        //             // series.hide();

        //             // series.appear(1000);
        //         }else{
        //             // var volumeAxisRenderer = am5xy.AxisRendererY.new(root, {});
        //             // volumeAxisRenderer.grid.template.set("forceHidden", true);
        //             // volumeAxisRenderer.labels.template.set("forceHidden", true);

        //             // var volumeAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
        //             //   height: am5.percent(25),
        //             //   y: am5.percent(100),
        //             //   centerY: am5.percent(100),
        //             //   panY:false,
        //             //   renderer: volumeAxisRenderer
        //             // }));


        //             // Add series
        //             // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
        //             var volumeSeries = chart.series.unshift(am5xy.ColumnSeries.new(root, {
        //                 legendLabelText: this.drawdownJson[val.type],
        //               name: "Volume Series",
        //               xAxis: xAxis,
        //               yAxis: yAxis,
        //               valueYField: "y",
        //               valueXField: "x",
        //               tooltip: am5.Tooltip.new(root, {
        //                 labelText: "[bold]Live Daily Drawdown[/]: {valueY} \n [bold]Date[/]: {valueX.formatDate('dd MMM yyyy')}",
        //               })
        //             }));

        //             volumeSeries.columns.template.setAll({ width: am5.percent(40) })
        //             volumeSeries.data.setAll(val.data);
        //             //legend.data.unshift(volumeSeries);
        //         }
        //     })
        //      xAxis.get("renderer").labels.template.setAll({
        //         fill: root.interfaceColors.set("fill", am5.color(this.xAxisColor)),
        //         fontSize: 12,
        //     });
        //     yAxis.get("renderer").labels.template.setAll({
        //         fill: root.interfaceColors.set("fill", am5.color(this.yAxisColor)),
        //         fontSize: 12,
        //     });
        //     legend.data.setAll(chart.series.values);
        //     chart.appear(1000, 100);
        // },
        getDrawdownData(){
            let formData = {};
            let type = '';
            if(this.tradingProfitTab == this.leaderDetail.trader.stats.profile.baseCurrencyName){
                type = 'TOTAL_PROFIT_MONEY,CLOSED_PROFIT_MONEY,DRAWDOWN_DAILY_MONEY'
            }else{
                type = 'TOTAL_PROFIT,CLOSED_PROFIT,DRAWDOWN_DAILY'
            }
            this._runGetDrawdownChartData({ globalParams: {}, localParams: { provider_id: this.divide9(this.$route.query.id), type: type, timeframe: this.dateDropSelected, parameter: this } })
        },

        setTimeframe(date_drop){
            this.$emit('updateSelectedTimeFrame',date_drop)
        },
        destroyChart(){
            let chartElement = am4core.registry.baseSprites.find((sprite) => sprite.htmlContainer.id === "trader_portfolio");
            if (chartElement) {
                chartElement.dispose();
            }
        },
        changeTradingProfitTab(tab){
            this.tradingProfitTab = tab;
            this.getDrawdownData();
        }

    }
}
</script>


<style>
    .drawdownchart{
        height: 400px;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/website/copy-trade/leader-detail/Charts/drawdown-chart.vue